import { useStatsigClient } from "@statsig/react-bindings";

/**
 * SRT 1.0 退場：gate 開啟時，Admin Center 隱藏 SRT 的啟用 toggle、底層維持常開，
 * 啟用控制權收回 MAAC，僅保留功能說明卡片。
 * 對應 Statsig gate "enable_srt1.0_sunset_info_ac"。
 */
export const useEnableSrt10SunsetInfoAc = (): boolean => {
  const statsigClient = useStatsigClient();
  return statsigClient.checkGate("enable_srt1.0_sunset_info_ac");
};
